export enum CommunicationType {
  SUGGESTIONS = 'suggestions',
  MESSAGES = 'messages'
}